import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {IFeaturePosition} from "../server/IDjPsychoData";
import {DjPsychoSymbol} from "../reels/DjPsychoSymbol";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoXKnobRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (DjPsycho.model.xKnobData.reelId > -1);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            xKnobData: IFeaturePosition = DjPsycho.model.xKnobData,
            xKnobSymbol: DjPsychoSymbol = DjPsycho.reelView.getVisibleSymbolAt(xKnobData.reelId, xKnobData.symId);

        tl.add([
            () => {
                // #153
                DjPsycho.soundPlayer.playSound(DjPsychoSound.FEATURE_X_KNOB);

                xKnobSymbol.visible = false;

                controller.setSkipCallback(() => {
                    this.onSkip(tl);
                });
            },
            DjPsycho.xKnob.playSymbolAnimation(xKnobSymbol.x, xKnobSymbol.y)
        ]);
        tl.add([
            () => {
                xKnobSymbol.visible = true;
            },
            DjPsycho.totalMultiplier.setMultiplier(DjPsycho.model.gameData.currentMultiplier),
            DjPsycho.xKnob.playHandAnimation()
        ]);
        tl.add([
            () => {
                // #153
                DjPsycho.soundPlayer.playSound(DjPsychoSound.FEATURE_TURN_TO_WILD);

                xKnobSymbol.visible = false;
            },
            DjPsycho.xKnob.playTransformAnimation()
        ]);
        tl.add(() => {
            xKnobSymbol.updateTexture(xKnobData.symName);
            xKnobSymbol.visible = true;
        });
    }

    private onSkip(tl: TimelineLite): void {
        tl.timeScale(4);
    }
}